import { Framebuffer, Texture2D, isWebGL2 } from '@luma.gl/core';
export function createRenderTarget(gl, opts) {
  return new Framebuffer(gl, {
    id: opts.id,
    attachments: {
      [36064]: new Texture2D(gl, { ...(opts.float && {
          format: isWebGL2(gl) ? 34836 : 6408,
          type: 5126
        }),
        mipmaps: false,
        parameters: {
          [10241]: 9729,
          [10240]: 9729,
          [10242]: 33071,
          [10243]: 33071
        }
      })
    }
  });
}
//# sourceMappingURL=utils.js.map